module.exports = __webpack_public_path__ + "static/media/honesty.8e72f1c0.png";